export function IconHeart({ size = 24, className }: { size?: number; className?: string }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.75}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      focusable="false"
      aria-hidden="true"
    >
      {/* Handflaeche unten: U-Mulde + Handgelenk-Andeutung */}
      <path d="M4 15 C4 18 7 20 12 20 C17 20 20 18 20 15" />
      <path d="M5 15 V18" />
      <path d="M19 15 V18" />
      {/* Herz darueber, sitzt in der Hand-Mulde */}
      <path d="M12 14 C10.5 12 7 11.5 7 9 C7 7.5 8.2 6.5 9.5 6.5 C10.5 6.5 11.5 7.1 12 8 C12.5 7.1 13.5 6.5 14.5 6.5 C15.8 6.5 17 7.5 17 9 C17 11.5 13.5 12 12 14 Z" />
    </svg>
  );
}
